import { connect } from 'react-redux';
import MHoldOrderPage from './MHoldOrderPage';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import { rowClick, rework } from 'src/actions/liveOrderAction';
import { downloadURL } from 'src/actions/completeOrderAction';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';
import { getMHoldOrderData } from 'src/actions/manufacturAction';

export const mapStateToProps = (state: AppState) => {
    return {
        mHoldOrderData: state.manufactur.mHoldOrderData
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onComponentDidMount: () => {
            // dispatch(getHoldOrderData);
        },
        onComponentWillMount: () => {
            dispatch(doCheckAuthentication);
            dispatch(getMHoldOrderData);
        },
        reload: () => {
            dispatch(getMHoldOrderData);
        },
        onRowClick: (orderid: string, rowData: string) => {
            dispatch(rowClick(orderid, rowData));
        },
        onDownloadClick: (filepath: string, fileName: string) => {
            dispatch(downloadURL(filepath, fileName, 'Initial Scan'));
        },
        submitRework: (column: Object) => {
            dispatch(rework(column, 'mhold'));
        },
    };
};

const MHoldOrderContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(MHoldOrderPage);

export default MHoldOrderContainer;



// WEBPACK FOOTER //
// ./src/components/MHoldOrder/MHoldOrderPageContainer.tsx